import { render } from "./PasswordLogin.vue?vue&type=template&id=5808e912&scoped=true&ts=true"
import script from "./PasswordLogin.vue?vue&type=script&lang=ts"
export * from "./PasswordLogin.vue?vue&type=script&lang=ts"

import "./PasswordLogin.vue?vue&type=style&index=0&id=5808e912&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5808e912"]])

export default __exports__